module.exports = vendors_zh_hans_e41c02f916726105d969;